import { tierFullName } from "../ChoosePlanCarePlus/planContent";

// Tier-aware label for the Care+ plan row in the legacy cart summaries (CartViewSummaryDE and
// CartViewBreakdown, still rendered for Care+ orders on the payment page). Those summaries used a
// single fixed key, so a Pro or Max plan was labelled "Care+ Plan" like every other tier.
//
// The tier names live in the choose_plan_care_plus namespace — the same source the Care+ cart card
// and the Choose Plan CTA read — so a tier is never spelled out inside a component.
//
// A cart with no tier (legacy non-tiered subscriptions, tier = null) keeps the original generic
// label: getCarePlusPlanFields already reports fee 0 for those, so the row is normally hidden, but
// the fallback keeps the label correct if it ever renders.
// `language` is `string | undefined` at every call site (react-router's useParams). The summaries
// already hand that straight to translate(), which is untyped JS, so this keeps the same contract
// rather than forcing a non-null assertion on the callers.
export const carePlusPlanRowLabel = (
  tier: string | null | undefined,
  language: string | undefined,
  translate: (lang: string | undefined, namespace: string, key: string) => string,
): string => {
  const generic = translate(language, "default", "OrderWindow/care_plus_plan_fee");
  if (!tier) return generic;

  const t = (key: string, fallback: string) =>
    translate(language, "choose_plan_care_plus", key) || fallback;

  // HL-12122: the V3 Monthly plan is not a Care+ tier.
  if (tier === "monthly") return t("plan_row_monthly", "Monthly Plan");
  return `${tierFullName(tier, t)} ${t("plan_suffix", "Plan")}`;
};
